import { Button, EmptyState, LoadingState } from "@qualtio-workhub/ui";
import { CircleAlert, RotateCcw } from "lucide-react";
import type { ReactNode } from "react";
import { useI18n } from "../i18n/provider";

export function QueryFeedback({
  loading,
  error,
  onRetry,
  emptyTitle,
  emptyDescription,
  emptyAction,
}: {
  loading: boolean;
  error: string | null;
  onRetry: () => Promise<void>;
  emptyTitle: string;
  emptyDescription?: string;
  emptyAction?: ReactNode;
}) {
  const { t } = useI18n();

  if (error) {
    return (
      <EmptyState
        role="alert"
        title={t("work.loadError")}
        description={t("work.loadError.desc")}
        icon={<CircleAlert size={18} />}
        action={
          <Button size="sm" variant="secondary" onClick={() => void onRetry()}>
            <RotateCcw aria-hidden="true" size={14} />
            {t("common.retry")}
          </Button>
        }
      />
    );
  }

  if (loading) return <LoadingState label={t("app.loading")} />;

  return <EmptyState title={emptyTitle} description={emptyDescription} action={emptyAction} />;
}
